import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@repo/ui/components/ui/form";
import { useForm } from "react-hook-form";
import Chip from "@repo/ui/components/ui/chip";
import { useTranslations } from "next-intl";
import { cn } from "@repo/ui/lib/utils";

export default function ChipSelection({
  items,
  title,
  onSelectionChange,
  isProfile,
}: {
  items: Array<{ label: string; value: string }>;
  title: string;
  onSelectionChange: (v: string[]) => any;
  isProfile?: boolean;
}) {
  const t = useTranslations("SharedHelp");

  const form = useForm({
    defaultValues: {
      elements: [],
    },
  });

  function handleSelectAll() {
    form.reset();
    onSelect();
  }

  function onSubmit() {}

  function onSelect() {
    onSelectionChange(form.getValues().elements);
  }

  return (
    <div className="overflow-x-auto">
      <Form {...form}>
        <fieldset
          onSubmit={form.handleSubmit(onSubmit)}
          onChange={onSelect}
          className="space-y-8"
        >
          {title && (
            <div className="mb-10 max-md:mb-4">
              <FormLabel>
                <h2 className={cn({ "text-[30px]": isProfile })}>{title}</h2>
              </FormLabel>
            </div>
          )}
          <div className="flex gap-5 max-md:gap-4 flex-wrap max-md:flex-nowrap max-md:overflow-x-auto">
            <button type="button" onClick={handleSelectAll}>
              <Chip
                className="pointer-events-none"
                size="slim"
                variant={
                  form.getValues().elements.length === items.length ||
                  form.getValues().elements.length === 0
                    ? "solidSelected"
                    : "solid"
                }
              >
                {t("categories-all", { gender: "F" })}
              </Chip>
            </button>
            {items &&
              items.map((item: { label: string; value: string }) => (
                <FormField
                  key={item.value}
                  control={form.control}
                  name="elements"
                  render={({ field }) => {
                    return (
                      <FormItem
                        key={item.value}
                        className="flex flex-row items-start space-x-3 space-y-0"
                      >
                        <FormControl>
                          <label>
                            <Chip
                              size="slim"
                              variant={
                                field.value.includes(item.value as never)
                                  ? "solidSelected"
                                  : "solid"
                              }
                            >
                              {item.label}
                            </Chip>
                            <input
                              className="hidden"
                              type="checkbox"
                              {...field}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                return checked
                                  ? field.onChange([...field.value, item.value])
                                  : field.onChange(
                                      field.value?.filter(
                                        (value) => value !== item.value,
                                      ),
                                    );
                              }}
                              checked={field.value.includes(
                                item.value as never,
                              )}
                            />
                          </label>
                        </FormControl>
                      </FormItem>
                    );
                  }}
                />
              ))}
          </div>
          <FormMessage />
        </fieldset>
      </Form>
    </div>
  );
}
